import { render, staticRenderFns } from "./edit-status.vue?vue&type=template&id=79d36449"
import script from "./edit-status.vue?vue&type=script&lang=tsx"
export * from "./edit-status.vue?vue&type=script&lang=tsx"
import style0 from "./edit-status.vue?vue&type=style&index=0&id=79d36449&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports